import React from 'react';

const BusinessOpportunities: React.FC = () => {
  return (
    <section id="business-opportunities" className="section-padding bg-[rgb(138,201,9)]">
      <div className="container-custom">
      </div>
    </section>
  );
};

export default BusinessOpportunities;
